module.exports = __webpack_public_path__ + "static/media/disable-landing-bg.1c70e161.jpg";